// extracted by mini-css-extract-plugin
export default {"toolbar":"Toolbar_toolbar__jHFW3","title":"Toolbar_title__smwbr","checkbox":"Toolbar_checkbox__KI1Jm"};